// @flow
'use strict';

import { connect } from 'react-redux';

import ListaCte from './lista';

export default connect<*, *, *, *, *, *>()(ListaCte);
